import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../_services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let targetUrl: string = state.url;

    if (this.authenticationService.isAuthenticatedWithSelectedCompany()) {
      return true;
    }
    else {
      this.authenticationService.redirectUrl = targetUrl;
      if (this.authenticationService.isAuthenticated()) {
        this.router.navigate(['company-select']);
        return false;
      }
      else {
        this.router.navigate(['login'], { queryParams: { expiredSession: 'true' } });
        return false;
      }
    }
  }
}
